import M from 'materialize-css'
import Turbolinks from 'turbolinks'
import destroyMaterializeInstances from 'destroy_materialize_instances'
import Nanotube from 'nanotube'

Turbolinks.start()

document.addEventListener('turbolinks:load', () => {
  M.AutoInit()
  M.updateTextFields()
  Nanotube.init()
  makeVideoEmbedLinkCopyable()
  addPreloaderToVideoForm()
})

document.addEventListener('turbolinks:before-cache', () => {
  destroyMaterializeInstances()
  Nanotube.dispose()
})

function makeVideoEmbedLinkCopyable() {
  const copyButton = document.querySelector('#copy-embed-link')
  const embedLink = document.querySelector('#embed-link')
  if (copyButton == null || embedLink == null) {
    return
  }

  copyButton.addEventListener('click', () => {
    embedLink.disabled = false
    embedLink.select()
    document.execCommand('copy')
    embedLink.disabled = true
  })
}

function addPreloaderToVideoForm() {
  const form = document.querySelector('#video-form')
  const preloader = document.querySelector('#upload-preloader')
  const graphic = preloader?.querySelector('.determinate')
  if (form == null || preloader == null || graphic == null) {
    return
  }

  graphic.style.width = '0%'

  form.addEventListener('submit', e => {
    e.preventDefault()

    preloader.classList.remove('hide')
    const xhr = new XMLHttpRequest()
    xhr.upload.addEventListener('progress', event => {
      const percentage = (event.loaded / event.total) * 100
      graphic.style.width = `${percentage}%`
    })
    xhr.addEventListener('load', event => {
      const url = (event.target).responseURL
      Turbolinks.visit(url)
    })

    xhr.open('post', form.action)
    xhr.send(new FormData(form))
  })
}
